var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"clippath"},React.createElement("rect",{"width":"32","height":"32","fill":"none"}))),React.createElement("g",{"clipPath":"url(#clippath)","key":1},React.createElement("path",{"d":"M29.63,0H2.36C1.08-.01,.02,1.03,0,2.31V29.69c.02,1.28,1.08,2.32,2.36,2.31H29.63c1.28,.02,2.35-1.03,2.37-2.31V2.3C31.99,1.02,30.91-.02,29.63,0ZM4.37,7.16c0,1.51,1.24,2.75,2.75,2.75,1.51,0,2.75-1.24,2.75-2.75,0-1.51-1.24-2.75-2.75-2.75s-2.75,1.24-2.75,2.75ZM22.53,27.27h4.74v-8.38c0-4.11-.88-7.27-5.69-7.27-1.83-.07-3.56,.88-4.49,2.47h-.06v-2.09h-4.55v15.27h4.74v-7.55c0-1.99,.38-3.92,2.85-3.92s2.47,2.28,2.47,4.05v7.43Zm-13.04,0H4.74V11.99h4.75v15.27Z","fill":"#0a66c2","fillRule":"evenodd"}))]);
}

SocialLinkedin.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
